module.exports = __webpack_public_path__ + "static/img/samajuri (17).a1cb675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (17).jpg
// module id = 6Jxl
// module chunks = 0